// extracted by mini-css-extract-plugin
module.exports = {"Paid":"InvoicesList_Paid__251N3","Issued":"InvoicesList_Issued__tupi0"};